import { render, staticRenderFns } from "./DialogErrors.vue?vue&type=template&id=52f7dc77&"
import script from "./DialogErrors.vue?vue&type=script&lang=js&"
export * from "./DialogErrors.vue?vue&type=script&lang=js&"
import style0 from "./DialogErrors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports